import React, { useState, useEffect, useRef } from 'react';
import './RegisterDeliverable.css'; 
import axios from 'axios';
import axiosInstance from '../../axiosInstance';
import moment from 'moment-timezone';
import { v4 as uuidv4 } from 'uuid';
import { FaArrowLeft } from 'react-icons/fa';


const API_URL = process.env.REACT_APP_API_URL;


const Feedback = ({ onClose, feedbackId, setSelectedMessage, feedbackSummary, setFeedbackId }) => {
  const [currentView, setCurrentView] = useState('register');
  const [selectedContact, setSelectedContact] = useState(null);
  const [lastLogin, setLastLogin] = useState(null);
  const [email, setEmail] = useState('');
  const [googleDriveLink, setGoogleDriveLink] = useState('');
  const [googleDriveID, setGoogleDriveID] = useState('');
  const uuid = uuidv4();
  const [searchFeedback, setSearchFeedback] = useState('');
  const [feedbackData, setFeedbackData] = useState(null);
  const [loading, setLoading] = useState(false);
  const registerFormRef = useRef(null);
  const feedbackFormRef = useRef(null);
  const [groupedFeedback, setGroupedFeedback] = useState({});
  const [selectedGroup, setSelectedGroup] = useState(null);

  useEffect(() => {
    if (feedbackSummary?.messages?.length > 0) {
      const sortedMessages = [...feedbackSummary.messages].sort((a, b) => {
        const dateA = new Date(a.stickyNotes?.[0]?.date || 0);
        const dateB = new Date(b.stickyNotes?.[0]?.date || 0);
        return dateB - dateA; // Most recent first
      });
  
      const grouped = sortedMessages.reduce((acc, message) => {
        const id = message._id;
        acc[id] = {
          label: message.initialFileRequest || 'Unknown',
          data:  message, 
        };
        return acc;
      }, {});
  
      setGroupedFeedback(grouped);
    }
  }, [feedbackSummary]);
  

  
  


  

 

  
 

  const handleToggleClick = (view) => {
    setCurrentView(view);
  };

  const getLastLogin = async (email) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`${API_URL}/api/contact`, { params: { email } });
      const contactData = Array.isArray(response.data) ? response.data[0] : null;
      setSelectedContact(contactData);
      if (contactData) {
        setLastLogin(contactData.lastLogin);
      }
    } catch (error) {
      console.error('Error fetching contact:', error);
      setSelectedContact(null);
      setLastLogin(null);
    }
    setLoading(false);
  };

 

  useEffect(() => {
    if (email.trim() && googleDriveID.trim()) {
      setLoading(true);
      getLastLogin(email); 
      setLoading(false);
      closeOrder();
    }
  }, [email, googleDriveID]);
  

  
 

  

  
 

  const closeOrder = async () => {
    const form = registerFormRef.current;
    if (!form) return;
  
    if (form.checkValidity()) {
      const formData = new FormData(form);
      const data = Object.fromEntries(formData.entries());
  
      try {
        const response = await axiosInstance.post(`${API_URL}/api/deliverable/close-order`, data);
        alert('Submission successful:', response.data);
        onClose();
      } catch (error) {
        alert('Error:', error.response ? error.response.data : error.message);
      }
    } else {
      form.reportValidity();
    }
  };
  
  
  
  return (
    <div className="register-Deliverable">
      <div>
        <button className="close-button" onClick={onClose}>x</button>
  
        <div className="toggle-buttons">
          <button
            className={`toggle-button ${currentView === 'search' ? 'active' : ''}`}
            onClick={() => handleToggleClick('search')}
          >
            Get Feedback
          </button>
          <button
            className={`toggle-button ${currentView === 'register' ? 'active' : ''}`}
            onClick={() => handleToggleClick('register')}
          >
            Close Order
          </button>
        </div>
  
        <div className="popup-content">
          <div className="mini_container">
            {currentView === 'register' ? (
              <form id="register-form" ref={registerFormRef} onSubmit={closeOrder}>
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  type="text"
                  name="googleDriveID"
                  placeholder="Google Drive ID"
                  required
                  value={googleDriveID}
                  onChange={(e) => setGoogleDriveID(e.target.value)}
                />
              </form>
            ) : (
              <>
                {feedbackSummary?.messages?.length > 0 ? (
                  <div className="edit-quiz">
                    {!selectedGroup ? (
                      <>
                        <h2>Select a Submission</h2>
                        <br />
                        {Object.entries(groupedFeedback).map(([id, { label, data }]) => (
                          <div
                            key={id}
                            className="feedback-preview"
                            onClick={() => setSelectedGroup(id)}
                            style={{ cursor: 'pointer' }}
                          >
                            <h4 style={{ color: data?.stickyNotes?.length > 1 ? '#bc509f' : 'inherit' }}>
                              {label}
                            </h4>
                            
                            {(!data || data.length === 0) && <p>No Feedback Given</p>}
                            <hr />
                          </div>
                        ))}
                      </>
                    ) : (
                      <>
                        <button onClick={() => setSelectedGroup(null)} className="back-button">
                        <FaArrowLeft /> 
                      </button>
                          {/* Render grouped sticky notes by date */}
                          {groupedFeedback[selectedGroup]?.data?.stickyNotes ? (
                        <>
                              {groupedFeedback[selectedGroup].data.stickyNotes.map(({ date, stickyNotes }, index) => (

                            <div key={index}>
                              <p><strong>{date}</strong></p>
                              {stickyNotes.map(({ page, text }, noteIndex) => (
                                <div key={noteIndex}>
                                  <p>pg. {page}:</p>
                                  {text.map((noteText, textIndex) => (
                                    <p key={textIndex}>{noteText}</p>
                                  ))}
                                </div>
                              ))}
                              <hr />
                            </div>
                          ))}

                          {/* Render alertDeliverable, googleDriveID, and email at the end */}
                         {/* Render alertDeliverable, googleDriveID, and email at the end */}
                          {groupedFeedback[selectedGroup]?.data?.alertDeliverable && (
                            <p><strong>Alert Deliverable:</strong> {groupedFeedback[selectedGroup].data.alertDeliverable}</p>
                          )}
                          <p><strong>Drive ID:</strong> {groupedFeedback[selectedGroup].data.googleDriveID}</p>
                          <p style={{ color: '#bc509f' }}>Email: {groupedFeedback[selectedGroup].data.email}</p>


                        </>


                        ) : (
                          <p>No sticky notes available for this group.</p>
                        )}
                      </>
                    )}
                  </div>
                ) : (
                  <div className="no-feedback-message">
                    <p>No feedback messages found for this user yet.</p>
                  </div>
                )}

              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
  
  
};

export default Feedback;
